var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.50293C5.15685 6.50293 6.5 5.15978 6.5 3.50293C6.5 1.84608 5.15685 0.50293 3.5 0.50293C1.84315 0.50293 0.5 1.84608 0.5 3.50293C0.5 5.15978 1.84315 6.50293 3.5 6.50293Z",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.5029C5.15685 15.5029 6.5 14.1598 6.5 12.5029C6.5 10.8461 5.15685 9.50293 3.5 9.50293C1.84315 9.50293 0.5 10.8461 0.5 12.5029C0.5 14.1598 1.84315 15.5029 3.5 15.5029Z",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.50293C14.1569 6.50293 15.5 5.15978 15.5 3.50293C15.5 1.84608 14.1569 0.50293 12.5 0.50293C10.8431 0.50293 9.5 1.84608 9.5 3.50293C9.5 5.15978 10.8431 6.50293 12.5 6.50293Z",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.5029C14.1569 15.5029 15.5 14.1598 15.5 12.5029C15.5 10.8461 14.1569 9.50293 12.5 9.50293C10.8431 9.50293 9.5 10.8461 9.5 12.5029C9.5 14.1598 10.8431 15.5029 12.5 15.5029Z",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWhite);
export default __webpack_public_path__ + "static/media/dashboard-white.baeab970f516f44dbe6b5052fce0d407.svg";
export { ForwardRef as ReactComponent };